export default __webpack_public_path__ + "static/media/CreditEntry2.82fce14e.svg";